export const getMaskStyle = (type) => {
	switch (type) {
		case 'primary':
			return {
				backgroundColor: 'rgba(0, 0, 0, 0.8)',
				backdropFilter: 'blur(1px)'
			};
		case 'secondary':
			return {
				backgroundColor: 'rgba(0, 0, 0, 0.75)',
				backdropFilter: 'blur(2px)'
			};
		default:
			return null;
	}
};
